/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 11/24/20
 * Time: 1:55 PM
 */

import React, {Component} from 'react';
import '../../ManageCamera.scss';
import {Row, Col, CardBody, Card} from "reactstrap";
import Lbl from "../../../../../../components/Label/Lbl";
import LabelInput from "../../../../../../components/Input/Input/TxtLbl";
import {Button, Checkbox, Dropdown, Icon, Input} from 'semantic-ui-react';
import Cookies from "js-cookie";
import axiosVisitortags from "../../../../../../axios/axios_visitortag";
import apiConfig from "../../../../../../axios/axios_api_services";
import * as common from "../../../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../../../store/Action";
import * as validator from "../../../../../../util/Validator";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../../assets/img/sweet/question.svg";
import cloneDeep from "lodash/cloneDeep";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";

class App extends Component {
  state = {
    cameraPublicIp: "",
    rtspPort: "",
    username: "",
    password: "",
    channel: "",
    cameraSuffix: "",
    branches: [],
    branchId: '',
    passwordType: 'password',
    cameraId: "",
    visitorCameraStatus: "ACTIVE",
    visitorCameraId: 0
  };

  handleChange = (name) => event => {
    let value = event.target.value;
    if (name === "cameraPublicIp") if (!validator.keyPressDigitAndDotValidation(value)) return;
    if (name === "rtspPort") if (!validator.portValidation(value)) return;

    this.setState({
      [name]: value
    });
  };

  validationHandler = () => {
    let {cameraPublicIp, rtspPort, username, password, channel, branchId, cameraId} = this.state;
    branchId === "" ? common.notifyMessage("Branch cannot be empty") :
      cameraId.trim() === "" ? common.notifyMessage("Camera Id cannot be empty") :
        !validator.ipAddressValidation(cameraPublicIp) ? common.notifyMessage("Please enter valid public IP address") :
          rtspPort === "" ? common.notifyMessage("RTSP Port cannot be empty") :
            channel.trim() === "" ? common.notifyMessage("Channel cannot be empty") :
              username.trim() === "" ? common.notifyMessage("Username cannot be empty") :
                password.trim() === "" ? common.notifyMessage("Password cannot be empty") :
                  swal({
                    title: "Do you want to proceed?",
                    icon: are_you_sure_icon, closeOnClickOutside: false,
                    buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
                  })
                    .then((value) => {
                      switch (value) {
                        case "action":
                          this.submitHandler();
                          break;
                        default:
                      }
                    });
  };

  submitHandler = () => {
    const obj = cloneDeep(this.state);
    obj.visitorCameraStatus = obj.visitorCameraStatus ? "ACTIVE" : "INACTIVE";
    obj.branch = obj.branchId;
    delete obj.branches;
    delete obj.passwordType;

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosVisitortags.patch(apiConfig.IVCA_CORPORATE_BRANCH_CAMERA({
      corporateId: this.props.usr_obj.corporateId,
      branchId: obj.branchId
    }), obj, {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);

        if (response.data.success) {
          this.props.closeModal();
          common.notifyMessage(response.data.message, 2);
          return;
        }
        common.warningAlert(response.data.message, response.data.success ? 0 : 1);
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.submitHandler();
        } else {
          this.props.spinnerHandler(false);
        }
      });
  };

  viewPassword = () => {
    let i = document.getElementById("password-field");
    this.setState({passwordType: i.type === "password" ? "text" : "password"});
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };
  fillData = () => {
    let selectedObj = cloneDeep(this.props.selectedObj);
    this.setState({...selectedObj,branchId: selectedObj.branch.branchId,visitorCameraStatus: selectedObj.visitorCameraStatus === "ACTIVE"})
  };

  componentWillMount() {
    this.fillData();
  }

  render() {
    let {branches} = this.props;
    let {branchId, passwordType,visitorCameraStatus} = this.state;

    return (
      <div>
        <MDBModal isOpen={true} toggle={() => {
        }} size="md">
          <MDBModalHeader className={"title"} toggle={this.props.closeModalHandler}>
            Update Camera Details
          </MDBModalHeader>
          <MDBModalBody>
            <Row className={"ivca-create-camera"}>
              <Col>
                <Card>
                  <CardBody>
                    <Row>
                      <Col md={7}>
                        <div className={"none-padding"}>
                          <Lbl required>Branch</Lbl>
                          <Dropdown
                            fluid selection search
                            options={branches} value={branchId}
                            placeholder={"Select branch"}
                            onChange={(event, {value}) => {
                              this.setState({branchId: value})
                            }}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className={"none-padding"}>
                          <Lbl required>Camera ID</Lbl>
                          <LabelInput
                            placeholder={"Camera ID"}
                            value={this.state.cameraId}
                            onChange={this.handleChange('cameraId')}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={7}>
                        <div className={"none-padding"}>
                          <Lbl required>Public IP</Lbl>
                          <LabelInput
                            placeholder={"Public IP"}
                            value={this.state.cameraPublicIp}
                            onChange={this.handleChange('cameraPublicIp')}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className={"none-padding"}>
                          <Lbl required>RTSP Port</Lbl>
                          <LabelInput
                            placeholder={"RTSP Port"}
                            value={this.state.rtspPort}
                            onChange={this.handleChange('rtspPort')}
                          />
                        </div>
                      </Col>
                    </Row>


                    <div className={"none-padding"}>
                      <Lbl required>Channel</Lbl>
                      <LabelInput
                        placeholder={"Channel"}
                        value={this.state.channel}
                        onChange={this.handleChange('channel')}
                      />
                    </div>

                    <Row>
                      <Col md={6}>
                        <div className={"none-padding"}>
                          <Lbl required>Username</Lbl>
                          <LabelInput
                            placeholder={"Username"}
                            value={this.state.username}
                            onChange={this.handleChange('username')}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className={"none-padding"}>
                          <Lbl required>Password</Lbl>
                          <Input id={"password-field"} type={"password"}
                                 onChange={this.handleChange('password')}
                                 value={this.state.password}
                                 style={{width: '100%'}}
                                 icon={<Icon onClick={() => this.viewPassword(false)}
                                             onClick={() => this.viewPassword(true)}
                                             name={passwordType === "password" ? 'eye' : 'eye slash'} circular link/>}
                                 placeholder='Password'/>
                        </div>
                      </Col>
                    </Row>

                    <hr/>
                    <div className={"none-padding"}>
                      <Lbl>Suffix Parameter</Lbl>
                      <LabelInput
                        placeholder={"Suffix"}
                        value={this.state.cameraSuffix}
                        onChange={this.handleChange('cameraSuffix')}
                      />
                    </div>
                    <br/>
                    <div>
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                checked={visitorCameraStatus}
                                onChange={() => this.setState({visitorCameraStatus: !visitorCameraStatus})}
                                toggle
                                label={visitorCameraStatus ? 'Active' : 'In-Active'}/>
                    </div>
                    <br/>
                    <div className={"align-center"}>
                      <Button
                        className="px-5"
                        onClick={this.validationHandler}
                      >Update Camera</Button>
                    </div>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // usr obj
  usr_obj: state.userReducer.user,
});
const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
